import React, { PropsWithChildren } from "react";
import { styles } from "./PaperWrapper.style";

const PaperWrapper: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  return <div className={styles.paper()}>{children}</div>;
};

export default PaperWrapper;
